import React from 'react';

import { isFedRamp } from '@atlassian/atl-context';
import { SiteAnalyticsPageLoader } from '@confluence/confluence-analytics/entry-points/AnalyticsPagesLoaders';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { Redirection } from '@confluence/route-manager';
import type { RouteMatch } from '@confluence/route';
import { fg } from '@confluence/feature-gating';

export const SiteAnalyticsRoute = ({ search }) => {
	//TODO - CCIR-11: Clean up this feature gate once the migration is complete
	if (!fg('confluence_frontend_analytics_ui_migration')) {
		const isFedrampEnv = isFedRamp();

		const url = isFedrampEnv
			? '/wiki/plugins/servlet/ac/com.addonengine.analytics.moderate/analytics-instance-page'
			: '/wiki/plugins/servlet/ac/com.addonengine.analytics/analytics-instance-page';
		return <Redirection href={`${url}${search}`} />;
	}

	return <SiteAnalyticsPageLoader />;
};

SiteAnalyticsRoute.NAVIGATION_PARAMS = ({ name, params: { tab } }: RouteMatch) => {
	return {
		Screen: {
			// screenEvent will be handled in the page components
			pageState: {
				routeName: name,
				tab,
			},
		},
		MainLayout: {
			navView: ADMIN_HOME_ID,
		},
	};
};
